{
  "version": 1,
  "asset_id": "58378d9b-3ab4-4948-b790-2dbb58339ebc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/58378d9b-3ab4-4948-b790-2dbb58339ebc/sleeve-dissection-revision-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/58378d9b-3ab4-4948-b790-2dbb58339ebc/sleeve-dissection-revision-480.webp",
  "original_filename": "sleeve-dissection-revision-480.webp",
  "size": 18798,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:43:01Z"
}
